import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  filterIcon: { marginRight: 8 },
  filtersBox: {
    display: 'flex',
    gap: theme.spacing(4),
    width: '100%',
    [theme.breakpoints.down('xl')]: {
      gap: theme.spacing(2),
    },
    [theme.breakpoints.down('lg')]: {
      gap: theme.spacing(0),
      justifyContent: 'space-between',
    },
    [theme.breakpoints.downLandscape('lg')]: {
      ...(theme.isMobileDevice && {
        gap: theme.spacing(0),
        justifyContent: 'space-between',
      }),
    },
  },
  button: {
    backgroundColor: '#F4F4F4',
    fontSize: 14,
    '&:hover': {
      backgroundColor: '#F4F4F4 !important',
    },
  },
  plusIcon: {
    fontSize: 24,
    marginRight: theme.spacing(0.5),
  },
  iconButton: {
    backgroundColor: '#F4F4F4',
    borderRadius: 4,
    minWidth: 24,
    padding: 2,
    '&:hover': {
      backgroundColor: '#F4F4F4 !important',
    },
  },
}));
